module.exports = __webpack_public_path__ + "img/oa-fileico.1824bb55.png";